/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_ClearInputs */



/**
* | output |
* | --- |
* | "Clear all draws" |
*
* @param {Raffle_ClearInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_clear = /** @type {((inputs?: Raffle_ClearInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_ClearInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer tous les tirages")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar todos los sorteos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Limpar todos os sorteios")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancella tutte le estrazioni")
	return /** @type {LocalizedString} */ ("Clear all draws")
});